import FlexiText from "slotworks/graphics/elements/flexi-text";

export default class FlexiInputText extends FlexiText {

    public selected: boolean;

    private defaultText: string = "";
    private defaultValue: number = 0;

    private currentText: string;
    private currentValue: number;

    public addTarget(target: PIXI.Text | HTMLElement) {
        if (target instanceof HTMLElement) {
            target.addEventListener("input", this.onHTMLInputChange as any);
            target.addEventListener("focus", this.select);
            target.addEventListener("blur", this.deselect);
        } else {
            throw new Error("Not implemented");
        }

        super.addTarget(target);
    }

    public setDefaults(text: string, value: number) {
        this.defaultText = text;
        this.defaultValue = value;

        this.setText(text);
    }

    public setValue(value: number) {
        this.currentValue = value;
        this.currentText = this.currentValue.toString();

        this.setText(this.currentText);
    }

    public setText(text: string) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                const input = target as HTMLInputElement;
                input.value = text;
            } else {
                super.setText(text);
            }
        }
    }

    public setHighlight(highlight: boolean) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                const input = target as HTMLInputElement;
                input.classList.toggle("highlight", highlight);
            } else {
                throw new Error("Not implemented");
            }
        }
    }

    public getValue(): number {
        return this.currentValue;
    }

    public on(event: InputTextEvent, handler: Function) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                if (event === InputTextEvent.CHANGE) {
                    target.addEventListener("input", handler as any);
                }
            } else {
                throw new Error("Not implemented");
            }
        }
    }

    public off(event: InputTextEvent, handler: Function) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                if (event === InputTextEvent.CHANGE) {
                    target.removeEventListener("input", handler as any);
                }
            } else {
                throw new Error("Not implemented");
            }
        }
    }

    public destroy() {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.removeEventListener("input", this.onHTMLInputChange as any);
            } else {
                throw new Error("Not implemented");
            }
        }

        super.destroy();
    }

    private onHTMLInputChange = (event: any) => {
        let text;
        let value;

        const input = event.target as HTMLInputElement;
        text = input.value;

        if (isNaN(text as any)) {
            this.setText(this.currentText);
            value = this.currentValue;
        } else {
            value = parseFloat(text);

            if (text === "") {
                value = this.defaultValue;
                text = this.defaultText;
            }

            this.currentValue = Math.round(value * 100) / 100;
            this.currentText = this.currentValue.toString();
            this.setText(this.currentText);
        }
    }

    private select = (event: any) => {
        this.selected = true;
    }

    private deselect = (event: any) => {
        this.selected = false;
    }
}

export class InputTextEvent {
    public static CHANGE: InputTextEvent = new InputTextEvent("change");

    private id: string;

    constructor(id: string) {
        this.id = id;
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/graphics/elements/flexi-input-text.ts